module.exports = __webpack_public_path__ + "img/ui-ux-tab.d1f83ff8.jpg";